(ns bp-libs.design-system.components.grid)

(defn- thumb-container
  "Using elements padding-left and padding-bottom
  instead of grid gap to keep browser compatibility
  (chrome 65). Gap is supported from chrome 66."
  [{:keys [classes]} thumb]
  ^{:key (:title thumb)}
  [:div {:class (concat classes
                        ["w-full"])}
   thumb])

(defn grid
  {:storybook {:items   {:name         "Grid items"}
               :columns {:name         "Number of columns"
                         :required     true
                         :defaultValue 6
                         :control      {:type "select" :options [1 2 3 4 5 6]}}
               :title   {:name         "Grid title"
                         :defaultValue "A Grid Title"
                         :control      {:type "text"}}}}
  [{:keys [items title columns react-ref on-key-down line-classes items-classes]}]
  (let [columns-class (case columns
                        1 "basis-full"
                        2 "basis-1/2"
                        3 "basis-1/3"
                        4 "basis-1/4"
                        5 "basis-1/5"
                        6 "basis-1/6"
                        "basis-full")]
    ^{:key title}
    [:div {:class (concat ["w-full space-y-4"] line-classes)
           :on-key-down on-key-down
           :ref react-ref}
     (when (seq title)
       [:p {:class ["text-2xl text-white font-medium"]}
        title])
     (into [:div {:class ["flex flex-wrap"
                          "w-full"]}]
           (map (fn [thumb] (thumb-container {:classes (concat items-classes [columns-class])} thumb))
                items))]))
